const getLivestockAge = listing => {
  let age = ''

  if (listing.meta && 'ageMin' in listing.meta && listing.meta.ageMin && listing.meta.ageMax) {
    if (listing.meta.ageMin === listing.meta.ageMax || !listing.meta.ageMax) {
      age = `${listing.meta.ageMin} mo`
    } else {
      age = `${listing.meta.ageMin}-${listing.meta.ageMax} mo`
    }
  }

  return age
}

export default getLivestockAge
